export enum MatomoEventCategory {
    Talent = 'Talent',
    Profile = 'Profile',
    User = 'User',
    Marketplace = 'Marketplace',
}
